<template>
  <el-dialog :visible.sync="visible"
             :title="title"
             center
             width="550px">
    <el-form :model="model"
             ref="writeOffForm"
             label-width="150px"
             size="small">
      <el-form-item label="输入订单核销码："
                    prop="note">
        <el-input placeholder="订单核销码"
                  class="input-width"
                  v-model.trim="model.writeOffCode"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary"
                 size="medium"
                 :loading="loading"
                 @click="submit">确认</el-button>
      <el-button size="medium"
                 @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { orderWriteOff } from '@/api/order'

// 订单核销
export default {
  name: 'writeOffDialog',
  data() {
    return {
      visible: false,
      title: null,
      loading: false,
      model: {}
    }
  },
  methods: {
    init() {
      this.model = {}
      this.$nextTick(() => {
        this.$refs.writeOffForm.clearValidate()
      })
    },
    show(id) {
      this.init()
      // 添加数据处理
      this.model.orderSonId = id
      this.visible = true
      this.loading = false
      this.title = '您确定核销订单吗？'
    },
    submit() {
      // 提交保存
      this.$refs.writeOffForm.validate((valid) => {
        if (valid) {
          // 验证通过
          this.loading = true
          orderWriteOff(this.model).then(res => {
            this.loading = false
            this.$emit('ok')
            this.close()
          }).catch(err => {
            this.loading = false
          })
        }
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
<style scoped>
.input-width {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/oms/order/components/writeOffDialog.vue